/* eslint-disable max-len */
import clsx from 'clsx';

type MSPastWorkIconProps = {
  className?: string;
  color?: string;
};

export const MSPastWorkIcon = ({
  className,
  color = '#3B3B3B',
}: MSPastWorkIconProps) => {
  return (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('icon', className)}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25642 18.5439V2.75768H18.7803V18.5439H3.25642ZM0.833008 1.97178C0.833008 1.10371 1.55634 0.399994 2.44861 0.399994H19.5881C20.4804 0.399994 21.2037 1.10371 21.2037 1.97179V2.74066H23.2057C24.7672 2.74066 26.033 3.97217 26.033 5.4913V22.8494C26.033 24.3685 24.7672 25.6 23.2057 25.6H6.06623C4.50476 25.6 3.23892 24.3685 3.23892 22.8494V20.9016H2.44861C1.55634 20.9016 0.833008 20.1979 0.833008 19.3298V1.97178ZM5.66233 20.9016V22.8494C5.66233 23.0664 5.84316 23.2423 6.06623 23.2423H23.2057C23.4288 23.2423 23.6096 23.0664 23.6096 22.8494V5.4913C23.6096 5.27428 23.4288 5.09835 23.2057 5.09835H21.2037V19.3298C21.2037 20.1979 20.4804 20.9016 19.5881 20.9016H5.66233Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8264 7.42539C16.2996 7.88576 16.2996 8.63216 15.8264 9.09253L10.5756 14.2009C10.1024 14.6612 9.33523 14.6612 8.86203 14.2009L6.43862 11.8432C5.96543 11.3828 5.96543 10.6364 6.43862 10.176C6.91182 9.71566 7.67903 9.71566 8.15223 10.176L9.71884 11.7001L14.1128 7.42539C14.5859 6.96502 15.3532 6.96502 15.8264 7.42539Z"
        fill={color}
      />
    </svg>
  );
};
